import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { AWS_URL } from "../../../configs/constants";
import { IBannerItems } from "../../../models/IBanner";
import { typo } from "../../../assets/fonts/font";
import CustomButton from "../../common/Button/CustomButton";
import colorConfigs from "../../../configs/colorConfigs";

interface TasteBudSectionProps {
  items: IBannerItems[];
}

const TasteBudSection: React.FC<TasteBudSectionProps> = ({
  items,
}: TasteBudSectionProps) => {
  if (items.length === 0) return null;

  return (
    <Grid container spacing={4}>
      {items.map((item, index) => (
        <Grid item xs={12} sm={4} key={index}>
          <Box sx={{     
            px: { xs: 4, sm: 8 },
            textAlign: "center" }}>
            <Box sx={{ mb: 3 }}>
              <img
                src={`${AWS_URL}/${item.asset}`}
                alt={`TasteBud ${index + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "30px",
                }}
              />
            </Box>
            <Typography sx={{ ...typo.bodyContent, lineHeight: 1.6 }}>
              {item.text}
            </Typography>
            <CustomButton
              buttonType="primary"
              href={item.btn_url}
              sx={{
                padding: "10px 40px",
                margin: "20px",
              }}
            >
              <Typography
                component="span"
                sx={{ ...typo.button, color: colorConfigs.tastebudButtonText }}
              >
                {item.btn_text}
              </Typography>
            </CustomButton>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default TasteBudSection;